import * as Types from '../../../../graphql-types'

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type acceptDiscountMutationVariables = Types.Exact<{
  enrolmentKey: Types.Scalars['String']
}>

export type acceptDiscountMutation = {
  acceptDiscount: {
    __typename: 'Discount'
    id: string
    name: string
    minimumSubtotalGross: number | null
    discountAmount: number | null
    discountPercentage: number | null
    customerEnrolled: boolean
    enrolmentKey: string | null
    restaurant: { __typename: 'Restaurant'; id: string } | null
  }
}

export const acceptDiscountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'acceptDiscount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'enrolmentKey' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acceptDiscount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'enrolmentKey' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'enrolmentKey' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'minimumSubtotalGross' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discountAmount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discountPercentage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerEnrolled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enrolmentKey' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'restaurant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  acceptDiscountMutation,
  acceptDiscountMutationVariables
>
